export default {
  on: 'On',
  off: 'Off',
  lastUpdatedByUser: 'Last turned on by user',
  errorHandling303: 'We have a delay in the connection response, wait 30 seconds and try again. You can still turn on the lights.'
}